<template>
  <div class="dd-effects__catalog">
    <effect-item
      v-for="effect in effects"
      :key="effect.id"
      :effect="effect"
    />
  </div>
</template>
<script>
import EffectItem from "./EffectItem";
export default {
  name: "EffectList",
  components: {
    EffectItem
  },
  computed: {
    effects() {
      return this.$store.getters.effects;
    }
  }
};
</script>
